"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLinkTitleWrapper = exports.StyledIcon = exports.StyledLink = exports.LinkWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const wl_ui_kit_2 = require("@invent/wl-ui-kit");
exports.LinkWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
exports.StyledLink = (0, styled_components_1.default)(wl_ui_kit_2.Link) `
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: ${(0, wl_ui_kit_1.getColor)('link')};
`;
exports.StyledIcon = (0, styled_components_1.default)(wl_ui_kit_1.Icon) `
  padding-left: ${(0, wl_ui_kit_1.getSizeBy)(2)};
  color: inherit;

  & > path {
    fill: inherit;
  }
`;
exports.StyledLinkTitleWrapper = styled_components_1.default.div `
  text-wrap: wrap;
`;
